import { render } from "./accordion-item.vue?vue&type=template&id=21f94fb1&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"

import "./accordion-item.vue?vue&type=style&index=0&id=21f94fb1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f94fb1"]])

export default __exports__